module.exports = __webpack_public_path__ + "img/Logo.27748ef2.svg";